<section>
    <div class="agpr-monitoringSearchContexts-searchWithin" role="radiogroup">
        <span class="agpr-monitoringSearchContexts-searchWithinTitle">
          {{ 'Monitoring.searchContexts.searchWithin' | localize }}:
        </span>
        <div class="agpr-monitoringSearchContexts-searchContext u-mdBottomMargin">
            <div class="agpr-monitoringSearchContexts-searchContextOption">
                <agpr-radio
                    [id]="id + '.searchContextOption.textRadioButton'"
                    name="searchContextType"
                    [value]="searchContexts.text"
                    label="Monitoring.searchContexts.text"
                    hiddenLabel="Monitoring.searchContexts.text"
                    [(ngModel)]="searchContextType"
                    (ngModelChange)="updateSearchContext($event, text)"
                ></agpr-radio>
                <div *ngIf="searchContextType === searchContexts.text" class="agpr-monitoringSearchContexts-searchContextTextOptions">
                    <agpr-checkbox
                        [id]="id + '_searchContextTextOptions_headline'"
                        class="agpr-monitoringSearchContexts-searchContextCheckbox"
                        name="textOptions"
                        label="Monitoring.searchContexts.headline"
                        [binary]="true"
                        [disabled]="searchContextType != searchContexts.text"
                        [ngModel]="selectedSearchContexts.header"
                        (ngModelChange)="updateSearchContext($event, header)"
                    >
                    </agpr-checkbox>
                    <agpr-checkbox
                        [id]="id + '_searchContextTextOptions_lead'"
                        class="agpr-monitoringSearchContexts-searchContextCheckbox"
                        name="textOptions"
                        label="Monitoring.searchContexts.lead"
                        [binary]="true"
                        [disabled]="searchContextType != searchContexts.text"
                        [ngModel]="selectedSearchContexts.lead"
                        (ngModelChange)="updateSearchContext($event, lead)"
                    >
                    </agpr-checkbox>
                    <agpr-checkbox
                        [id]="id + '_searchContextTextOptions_body'"
                        class="agpr-monitoringSearchContexts-searchContextCheckbox"
                        name="textOptions"
                        label="Monitoring.searchContexts.body"
                        [binary]="true"
                        [disabled]="searchContextType != searchContexts.text"
                        [ngModel]="selectedSearchContexts.body"
                        (ngModelChange)="updateSearchContext($event, body)"
                    >
                    </agpr-checkbox>
                </div>
            </div>
        </div>

        <div class="agpr-monitoringSearchContexts-searchContext-image">
            <div class="agpr-monitoringSearchContexts-searchContextOption">
                <agpr-radio
                    [id]="id + '.searchContextOption.imageRadioButton'"
                    name="searchContextType"
                    tooltip="Monitoring.searchContexts.imageSearchTip"
                    label="Monitoring.searchContexts.images"
                    hiddenLabel="Monitoring.searchContexts.images"
                    [value]="searchContexts.images"
                    [ngModel]="searchContextType"
                    (ngModelChange)="updateSearchContext($event, images)"
                ></agpr-radio>
            </div>
        </div>
    </div>
</section>
